import { Box, Typography } from "@mui/material";
import ReactHtmlParser from "@/src/utils/html-parser";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";
import { stripHTMLTags } from "@/src/utils/strip-html-tags";
import { HEADING_SIZE } from "@/src/components/common/broadsheet/tokens";
import Panel from "@/src/components/common/broadsheet/panel";

export const hasHighlightsContent = (highlights?: string | null): boolean => {
  if (!highlights) return false;
  if (stripHTMLTags(highlights).length > 0) return true;

  return /<img\b/i.test(highlights);
};

const ArticleHighlights = ({ highlights }: { highlights: string }) => (
  <Box component="section" role="doc-abstract" aria-labelledby="highlights-title">
    <Typography
      component="h2"
      id="highlights-title"
      color="primary"
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <SpanTypography
        sx={{
          fontSize: HEADING_SIZE.section,
        }}
      >
        Highlights
      </SpanTypography>
    </Typography>
    <Panel
      component="aside"
      sx={{
        "& ul, & ol": {
          m: 0,
          pl: 2.5,
        },
        "& li": {
          mb: 0.5,
        },
        "& li:last-of-type": {
          mb: 0,
        },
        "& p:first-of-type": {
          mt: 0,
        },
        "& p:last-of-type": {
          mb: 0,
        },
      }}
    >
      {ReactHtmlParser(highlights)}
    </Panel>
  </Box>
);

export default ArticleHighlights;
